<template>
  <div class="show-hearing-devices pt-2 pb-3">
    <h6 class="is-bold text-evollu-gray-light mb-3">
      {{title}}
    </h6>

    <section v-if="hearingDevices.length > 0" class="px-2">

      <div v-for="(hearingDevice, index) in hearingDevices" :key="index">
        <h6 class="is-bold text-evollu-gray-light mb-3">
          {{$t(`clinical.people.anamnesis.${hearingDevice.ear}_ear`)}}
        </h6>

        <div class="px-2">

          <div class="answer-wrapper">
            <label>
              {{$t('clinical.appointments.hearing_devices.brand')}}:
            </label>
            <span class="is-bold">
              {{getTextAnswer(hearingDevice.brand)}}
            </span>
          </div>

          <div class="answer-wrapper">
            <label>
              {{$t('clinical.appointments.hearing_devices.model')}}:
            </label>
            <span class="is-bold">
              {{getTextAnswer(hearingDevice.model)}}
            </span>
          </div>

          <div class="answer-wrapper">
            <label>
              {{$t('clinical.appointments.hearing_devices.serial_number')}}:
            </label>
            <span class="is-bold">
              {{getTextAnswer(hearingDevice.serial_number)}}
            </span>
          </div>

          <div class="answer-wrapper">
            <label>
              {{$t('clinical.appointments.hearing_devices.supply_type')}}
            </label>
            <span class="is-bold">
              {{getSingleOptionAnswer(formOptions.supplyTypeOptions, hearingDevice.supply_type_id)}}
            </span>
          </div>

          <div class="answer-wrapper">
            <label>
              {{$t('clinical.appointments.hearing_devices.mold')}}:
            </label>
            <span class="is-bold">
              {{getBooleanAnswer(hearingDevice.mold)}}
            </span>
          </div>

          <div class="answer-wrapper">
            <label>
              {{$t('clinical.appointments.hearing_devices.obs')}}:
            </label>
            <span class="is-bold">
              {{getTextAnswer(hearingDevice.obs)}}
            </span>
          </div>
        </div>
      </div>
    </section>

    <section v-else class="px-2">
      <span>{{$t('clinical.people.no_data')}}</span>
    </section>
  </div>

</template>

<script>
import * as AnamnesisOptions from './AnamnesisOptions'
export default {
  props: {
    value: {
      type: Array,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('clinical.people.anamnesis.sale')
      }
    }
  },
  data: function () {
    return {
      formOptions: AnamnesisOptions
    }
  },
  computed: {
    hearingDevices: function () {
      let hearingDevices = []
      if (Array.isArray(this.value)) {
        hearingDevices = [...this.value]
        hearingDevices.sort((a, b) => b.ear.toLowerCase().localeCompare(a.ear.toLowerCase()))
      }
      return hearingDevices
    }
  },
  methods: {
    getTextAnswer: function (answer, defaultValue = 'N/A') {
      return answer || defaultValue
    },
    getBooleanAnswer: function (answer, defaultValue = 'N/A') {
      return answer === null ? defaultValue : (answer === true ? this.$t('yes') : this.$t('no'))
    },
    getSingleOptionAnswer: function (options, answerId, defaultValue = 'N/A') {
      let option = null
      if (answerId !== null) {
        option = options.find(option => option.id === answerId)
        if (option) {
          option = this.$t(option.name)
        }
      }
      return option || defaultValue
    },
  }
}
</script>
<style lang="scss">

@mixin for-desktop {
  @media (min-width: 766px) {
    @content;
  }
}

.answer-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75rem;
  justify-content: flex-start;

  label {
    margin-bottom: 0rem;
  }

  @include for-desktop {
    flex-direction: row;
    align-items: center;

    label {
      max-width: 80%;
    }

    span {
      margin-left: 0.25rem;
    }
  }
}

</style>